import { Link } from "react-router-dom";
import { siteInfo, navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="text-lg font-bold mb-4" style={{ fontFamily: "var(--font-heading)" }}>
                {siteInfo.name}
              </h4>
              <p className="text-sm text-background-300 leading-relaxed">
                {siteInfo.tagline}
              </p>
              <div className="flex gap-4 mt-4">
                <a href="#" className="w-9 h-9 flex items-center justify-center cursor-pointer rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 text-background-200 hover:text-background-50" aria-label="微信">
                  <i className="ri-wechat-line text-base" />
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center cursor-pointer rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200 text-background-200 hover:text-background-50" aria-label="微博">
                  <i className="ri-weibo-line text-base" />
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">快速导航</h4>
              <ul className="flex flex-col gap-2.5">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">服务支持</h4>
              <ul className="flex flex-col gap-2.5">
                <li><Link to="/category/zhinan" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors duration-200 whitespace-nowrap">使用指南</Link></li>
                <li><Link to="/category/anquan" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors duration-200 whitespace-nowrap">安全保障</Link></li>
                <li><Link to="/category/dongtai" className="text-sm text-background-300 hover:text-background-50 cursor-pointer transition-colors duration-200 whitespace-nowrap">平台动态</Link></li>
                <li><span className="text-sm text-background-300 cursor-pointer whitespace-nowrap">帮助中心</span></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-50">联系我们</h4>
              <ul className="flex flex-col gap-2.5">
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-phone-line text-base" />
                  <span>{siteInfo.phone}</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-300">
                  <i className="ri-mail-line text-base" />
                  <span>{siteInfo.email}</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-background-300">
                  <i className="ri-map-pin-line text-base mt-0.5" />
                  <span>{siteInfo.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有
            </p>
            <p className="text-xs text-background-400">
              {siteInfo.icp}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}